import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'config/reactQuery'
import { AccountService } from 'services/account'
import { PaymentMethodRequest } from 'services/account/types'

async function editPaymentMethod(request: PaymentMethodRequest) {
  return await AccountService.editPaymentMethod(request)
}

export const usePutPaymentMethod = () => {
  const { isLoading, mutate, error, status } = useMutation(
    (request: PaymentMethodRequest) => editPaymentMethod(request),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(['userId'])
      },
    },
  )

  return { isLoading, mutate, error, status }
}
